const INITIAL_STATE = {
	registro: {},
	modoTela: 'trilha',
	aguardando: false,
	lista: [],
	listaUsuario: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'TRILHA_CONHECIMENTO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'TRILHA_CONHECIMENTO_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};

        case 'TRILHA_CONHECIMENTO_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

		case 'TRILHA_CONHECIMENTO_USUARIO_SELECT_LISTADO':
            return {
				...state,
				listaUsuario: action.payload.data.filter(item => !item.administrador)
			};

        default:
            return state;
    }
}
